module.exports = __webpack_public_path__ + "static/media/LuisAlexisGodinezFlores.77e634ab.jpg";